/* src/app/components/controls/sem-quick-create-host/sem-quick-create-host.component.css */
.wg-quick-create-host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.wg-quick-create-iframe {
  flex: 1;
  width: 100%;
  border: 0;
  background: #fff;
}
/*# sourceMappingURL=sem-quick-create-host.component.css.map */
